import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import AllUniformAddPopup from "../../../../components/modelpopup/AllUniformAddPopup";

import Breadcrumbs from "../../../../components/Breadcrumbs";
import DeleteModal from "../../../../components/modelpopup/DeleteModal";
import UniformListFilter from "../components/UniformListFilter";
import { Table, Pagination,  } from "antd";
import {
  itemRender,
  pageSizeOptions,
} from "utils/table";
import {formatDateHandler2} from "utils/common"

import { SkeltonLoader } from "components/skeltonLoader";
import UniformsFilterDrawer from "components/Drawer/uniformsFilterDrawer";
import { useUniform } from "../context/uniformContext";
import Image from "components/Image"
import {  toast, Bounce } from 'react-toastify';
import { Button } from "components/Button";

//import { deleteUniformApi } from "api/services/uniforms";


const AllUniforms = () => {
  const {
    loading,
    setLoading,
    searchText,
    uniformData,
    view,
    setView, 
    pageSettings,
    handleGridChange,
    handleChange,
    handleSearchChange,
    handleFilterDrawer,
    showFilterDrawer,

    handleFilterChange,
    filters,
    handleInputChange,
    handleApplyFilter,
    filterLoading,
    
    handleUniformDetailPage,
    handleDateChange,

    uniformModal, setUniformModal,
    setSelectedUniform, selectedUniform,
    getUniformList   
  } = useUniform();

  const [deleteModal, setDeleteModal] = useState(false)


  const  handleEditUniform = (item) => {    
    setUniformModal(true)
  }

  const  handleDeleteUniform = (item) => {    
    //setUniformModal(true)
  }

  const displayUniformPositions = (uniformPos = []) => {
    const positions = uniformPos || [];
    const visiblePositions = positions.slice(0, 2); 
    const extraPositionCount = positions.length - 2; 

    return (
      <div className="d-flex flex-wrap">
       
        {visiblePositions.map((pos, index) => (
          <span
            key={index}
            className="badge badge-soft-primary px-3 py-1 m-1"
            style={{
              backgroundColor: "#f0f0f0", 
                    
              fontSize: "14px",   
            }}
            title={pos.name} 
          >
            {pos.name}
          </span>
        ))}

     
        {extraPositionCount > 0 && (
          <span
            className="badge px-3 py-1 m-1"
            style={{
              backgroundColor: "#f0f0f0",
              color: "#333",
              borderRadius: "12px",
              fontSize: "14px",
            }}
            title={positions.slice(2).map(dept => dept.name).join(", ")} 
          >
            +{extraPositionCount}
          </span>
        )}
      </div>
    );
  }

  const displayUniformColor = (colorVal, isText) => {
    return (
      <div
      className="d-flex align-items-center"
      style={{ gap: "8px" }} 
    >
      
      <span
        style={{
          backgroundColor: colorVal,
          border: "1px solid #ccc",
          width: "24px",
          height: "24px",
          borderRadius: "4px", 
          display: "inline-block",
        }}
      ></span>
      
   
     {isText ?  <span
        style={{
          display: "flex",
          alignItems: "center",
          height: "24px", 
          fontSize: "14px",
        }}
      >
        {colorVal}
      </span> : <></> }
    </div>
    )
   
  }

  const displayUniformSizes = (uniformsizes = []) => {
    if (!uniformsizes.length) return <span>-</span>;
  
    const sizeOrder = ["XS", "S", "M", "L", "XL", "XXL"];
  
   
    const sortedSizes = uniformsizes
      .slice() 
      .sort((a, b) => 
        (sizeOrder.indexOf(a.code) !== -1 ? sizeOrder.indexOf(a.code) : sizeOrder.length) -
        (sizeOrder.indexOf(b.code) !== -1 ? sizeOrder.indexOf(b.code) : sizeOrder.length)
      );
  

    const visibleSizes = sortedSizes.slice(0, 3);
    const extraSizesCount = sortedSizes.length - 3;
  
    return (
      <div className="d-flex align-items-center">
        {/* Display first 3 sizes */}
        {visibleSizes.map((size, index) => (
          <span
            key={index}
            className="badge badge-soft-secondary px-2 py-1 mx-1"
            style={{
              borderRadius: "12px",
              fontSize: "14px",
            }}
            title={size.code} // Show size code on hover
          >
            {size.code}
          </span>
        ))}
  
        {/* Show +X more if there are more than 3 sizes */}
        {extraSizesCount > 0 && (
          <span
            className="badge px-2 py-1 mx-1"
            style={{
              backgroundColor: "#f0f0f0",
              color: "#333",
              borderRadius: "12px",
              fontSize: "14px",
            }}
            title={sortedSizes.slice(3).map(size => size.code).join(", ")} // Show all remaining sizes on hover
          >
            +{extraSizesCount} more
          </span>
        )}
      </div>
    );
  };


  const displayUniformGender = (uniformGender) => {
    return (
      <span className="badge badge-soft-primary d-flex align-items-center justify-content-center w-75" >
      <i className={`la la-${uniformGender === 'M' ? 'mars' : uniformGender === 'F' ? 'venus' : 'genderless'} me-1`}></i>
         {uniformGender === 'M' ? 'Male' : uniformGender === 'F' ? 'Female' : uniformGender === 'U' ? 'Unisex' : ''}
    </span>)
  }
  
  
  const columns = [
    {
      title: "#",
      dataIndex: "id",
      sorter: (a, b) => a.id - b.id, 
      defaultSortOrder: "ascend",
      render: (text, record) => (
        <span className="table-avatar">
          {record.id}
        </span>
      )      
    },
    {
      title: "Image",
      dataIndex:"image",
      render: (text,record, index) => (
        <>
           <a onClick={() => handleUniformDetailPage(record.id, index)} className="avatar">
            <Image src={record.image} type="user" style={{ objectFit: "cover" }} />
          </a>
        </>
      )
    },
    {
      title: "Name",
      dataIndex: "name",
      sorter: true,
      render: (text, record, index) => (
        <div className="table-avatar d-flex align-items-center">
       
          <a
            onClick={() => handleUniformDetailPage(record.id, index)}
            className="profile-split d-flex flex-column justify-content-center ms-2"
          >
            {record.name}
          </a>
        </div>
      ),
    },

    // {
    //   title: "Color",
    //   dataIndex: "color",
    //   sorter: true,
    //   render: (text, record) => (
    //     <> 
    //       {displayUniformColor(record?.color, true)}
    //     </>
    //   )
    // },
  
    {
      title: "Gender",
      dataIndex: "gender",
      sorter: true,
      render: (text, record) => (
        <> {displayUniformGender(record?.gender)} </>
      )
    },

    {
      title: "Sizes",
      dataIndex: "sizes",
      sorter: true,
      render: (text, record) => (
        <> 
          {displayUniformSizes(record?.sizes)} 
        </> 
      )

  
    },
  
    // {
    //   title: "positions",
    //   dataIndex: "positions",
    //   sorter: true,
    //   render: (text, record) => (
    //     <>
    //     {displayUniformPositions(record?.positions)}
    //     </>
    //   )
    // },

    {
      title: "Status",
      dataIndex: "status",
      sorter: true,
      render: (text, record) => (
        <>
     
          <span className={`badge ${record?.status ? "badge-primary" : "badge-warning"}`} 
          style={{ fontSize: "0.75rem", padding: "5px 10px", fontWeight: "bold" }}
        >
          {record.status ? "Active" : "Inactive"}
        </span>
        </>
      )   
    
    },

    


    // {
    //   title: "Description",
    //   dataIndex: "description",
    //   sorter: true,
    //   render: (text, record) => (
    //     <span className="table-avatar">
    //       {record.description}
    //     </span>
    //   )   
    
    // },
    // {
    //   title: "Action",
    //   render: (text , record) => (
    //     <div className="dropdown dropdown-action text-end">
    //       <Link
    //         to="#"
    //         className="action-icon dropdown-toggle"
    //         data-bs-toggle="dropdown"
    //         aria-expanded="false"
    //       >
    //         <i className="material-icons">more_vert</i>
    //       </Link>
    //       <div className="dropdown-menu dropdown-menu-right">
          
    //         <Link
    //         onClick={()=>{
    //           setDeleteModal(true)
    //           setSelectedUniform(record)}}
    //           to="#"
    //           className="dropdown-item"             
    //         >
    //           <i className="fa fa-trash m-r-5" /> Delete
    //         </Link>
    //       </div>
    //     </div>
    //   ),
    // }
    
  ];

  


  const GridView = () => {
    if (loading) {
      return (
        <SkeltonLoader
          number={pageSettings?.pageSize}
          active={true}
          className="col-md-4 col-sm-6 col-12 col-lg-4 col-xl-3 p-2"
        />
      );
    } else {
      return (
        <>
          {uniformData.map((record, index) => {
            const isWhiteColor = record?.color?.toLowerCase() === "#ffffff" || record?.color?.toLowerCase() === "white";
            const isActive = record?.status || false; 

            return (
              <div 
                className="col-12 col-sm-6 col-md-4 col-lg-3"
                key={record.id}
                style={{
                  marginBottom: "16px",
                  display: "flex"
                }}
              >
                <div className="card shadow-sm" style={{ 
                  borderRadius: "8px", 
                  border: "1px solid #e0e0e0",
                  background: "#ffffff",
                  margin: 0,
                  boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                  position: "relative",
                  overflow: "hidden",
                  transition: "all 0.3s ease",
                  height: "100%",
                  width: "100%",
                  display: "flex",
                  flexDirection: "column"
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-4px)";
                  e.currentTarget.style.boxShadow = "0 8px 24px rgba(0,0,0,0.12)";
                  e.currentTarget.style.borderColor = "#D3001A";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow = "0 2px 8px rgba(0,0,0,0.08)";
                  e.currentTarget.style.borderColor = "#e0e0e0";
                }}
                >
                  {/* Action Buttons - Top Right */}
                  <div 
                    className="dropdown"
                    style={{
                      position: "absolute",
                      top: "8px",
                      right: "8px",
                      zIndex: 10
                    }}
                  >
                    <button
                      className="btn btn-link p-0"
                      type="button"
                      id={`dropdownMenu-${record.id}`}
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                      style={{
                        width: "32px",
                        height: "32px",
                        borderRadius: "6px",
                        border: "none",
                        background: "rgba(255, 255, 255, 0.9)",
                        color: "#6b7280",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        cursor: "pointer",
                        transition: "all 0.2s ease",
                        boxShadow: "0 2px 4px rgba(0,0,0,0.1)"
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.background = "#ef4444";
                        e.currentTarget.style.color = "#fff";
                        e.currentTarget.style.transform = "scale(1.1)";
                        e.currentTarget.style.boxShadow = "0 4px 8px rgba(239, 68, 68, 0.3)";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.background = "rgba(255, 255, 255, 0.9)";
                        e.currentTarget.style.color = "#6b7280";
                        e.currentTarget.style.transform = "scale(1)";
                        e.currentTarget.style.boxShadow = "0 2px 4px rgba(0,0,0,0.1)";
                      }}
                    >
                      <i className="material-icons" style={{ fontSize: "18px" }}>more_vert</i>
                    </button>
                    <ul className="dropdown-menu dropdown-menu-end" aria-labelledby={`dropdownMenu-${record.id}`} style={{ zIndex: 10000 }}>
                      <li>
                        <a className="dropdown-item" href="#" onClick={() => handleEditUniform(record.id)}>
                          <i className="fa-solid fa-pencil m-r-5"></i> Edit
                        </a>
                      </li>
                      <li>
                        <a className="dropdown-item text-danger" href="#" onClick={() => handleDeleteUniform(record.id)}>
                          <i className="fa-regular fa-trash-can m-r-5"></i> Delete
                        </a>
                      </li>
                    </ul>
                  </div>

                  {/* Uniform Image */}
                  <div 
                    style={{
                      width: "100%",
                      height: "220px",
                      overflow: "hidden",
                      background: "linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      padding: "16px"
                    }}
                  >
                    <a 
                      onClick={() => handleUniformDetailPage(record.id, index)} 
                      style={{ 
                        display: "block", 
                        width: "100%", 
                        height: "100%",
                        cursor: "pointer"
                      }}
                    >
                      {record?.image ? (
                        <img 
                          src={record.image} 
                          alt={record.name} 
                          style={{ 
                            width: "100%", 
                            height: "100%", 
                            objectFit: "contain",
                            transition: "transform 0.3s ease"
                          }}
                          onMouseEnter={(e) => e.target.style.transform = "scale(1.05)"}
                          onMouseLeave={(e) => e.target.style.transform = "scale(1)"}
                        />
                      ) : (
                        <div 
                          className="d-flex align-items-center justify-content-center text-muted"
                          style={{ 
                            width: "100%", 
                            height: "100%", 
                            fontSize: "13px",
                            fontWeight: "500"
                          }}
                        >
                          <i className="la la-image" style={{ fontSize: "64px", opacity: 0.2 }}></i>
                        </div>
                      )}
                    </a>
                  </div>

                  {/* Uniform Details */}
                  <div className="card-body" style={{ 
                    padding: "20px",
                    flex: 1,
                    display: "flex",
                    flexDirection: "column"
                  }}>
                    {/* Uniform Name */}
                    <div style={{
                      marginBottom: "16px"
                    }}>
                      <h5
                        style={{
                          color: "#1f2937",
                          fontSize: "18px",
                          fontWeight: "600",
                          marginBottom: 0,
                          lineHeight: "1.4",
                          cursor: "pointer",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis"
                        }}
                        onClick={() => handleUniformDetailPage(record.id, index)}
                        onMouseEnter={(e) => e.target.style.color = "#D3001A"}
                        onMouseLeave={(e) => e.target.style.color = "#1f2937"}
                        title={record?.name}
                      >
                        {record?.name}
                      </h5>
                    </div>

                    {/* Gender & Color */}
                    <div style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      marginBottom: "16px",
                      paddingBottom: "16px",
                      borderBottom: "1px solid #f0f0f0"
                    }}>
                      <div>{displayUniformGender(record?.gender)}</div>
                      <div 
                        style={{
                          backgroundColor: record?.color || "#ccc", 
                          width: "28px", 
                          height: "28px", 
                          borderRadius: "50%", 
                          display: "inline-block",
                          border: isWhiteColor ? "2px solid #ccc" : "none",
                          boxShadow: "0 2px 6px rgba(0,0,0,0.15)"
                        }}
                        title={record?.color || "Unknown Color"} 
                      />
                    </div>

                    {/* Positions/Departments */}
                    <div style={{
                      marginBottom: "16px",
                      minHeight: "40px"
                    }}>
                      {record?.positions?.length 
                        ? displayUniformPositions(record?.positions) 
                        : (
                          <span 
                            className="badge badge-soft-secondary" 
                            style={{ 
                              fontSize: "11px", 
                              padding: "4px 10px",
                              borderRadius: "6px"
                            }}
                          >
                            No Department
                          </span>
                        )
                      }
                    </div>

                    {/* Status and Sizes */}
                    <div style={{
                      marginTop: "auto",
                      paddingTop: "16px",
                      borderTop: "1px solid #f0f0f0",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      gap: "8px"
                    }}>
                      <span 
                        className={`badge ${isActive ? "badge-primary" : "badge-secondary"}`} 
                        style={{ 
                          fontSize: "11px", 
                          padding: "5px 12px", 
                          borderRadius: "6px",
                          fontWeight: "600"
                        }}
                      >
                        {isActive ? "Active" : "Inactive"}
                      </span>
                      <div style={{ flex: 1, display: "flex", justifyContent: "flex-end", flexWrap: "wrap", gap: "4px" }}>
                        {displayUniformSizes(record?.sizes)}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </>
      );
    }
  };



  
  
  
  const reloadPage = () => {
    getUniformList()
  }
  
  
  
  



  const deleteHandler = (props) => {
    console.log(selectedUniform, "LLLLLLLL")
    // deleteUniformApi(selectedUniform?.id).then(res=>{
    //   toast.success('Uniform deleted successfully!', {
    //     position: "top-right",
    //     autoClose: 5000,
    //     hideProgressBar: false,
    //     closeOnClick: false,
    //     pauseOnHover: true,
    //     draggable: true,
    //     progress: undefined,
    //     theme: "light",
    //     transition: Bounce,
    //     });
    //     getUniformList()
    //     setDeleteModal(false)
    // }).catch(e=>{
    //   toast.error('Error deleting uniform!', {
    //     position: "top-right",
    //     autoClose: 5000,
    //     hideProgressBar: false,
    //     closeOnClick: false,
    //     pauseOnHover: true,
    //     draggable: true,
    //     progress: undefined,
    //     theme: "light",
    //     transition: Bounce,
    //     });
    // })
  }

  return (
    <>
      <div className="page-wrapper">
        <div className="content container-fluid">
     
        
          <Breadcrumbs
           maintitle="Uniforms"
           title="Dashboard"
           subtitle="Uniforms"
           modal="#add_uniform"
           name="Add Uniform"
           view={view}
           setUniformModal={setUniformModal}
           setView={setView}  
           
          />



          <UniformListFilter
           filters={filters} 
           handleInputChange={handleInputChange} 
           searchPlaceholder={"Search Uniforms"} 
           handleFilterDrawer={handleFilterDrawer}
            handleFilterChange={handleFilterChange}
            loading={loading}
          />



          {view == "grid" ? (
            <div className="row">    
              <GridView />
              <div className="my-2 d-flex justify-content-end ">
                <div className="col-sm-12 col-md-6 ">
                <Pagination
                    pageSize={pageSettings?.pageSize}
                    pageSizeOptions={pageSizeOptions}
                    defaultCurrent={1}
                    current={pageSettings?.page}
                    total={pageSettings?.total}
                    // itemRender={itemRender}
                    onChange={handleGridChange}
                    showLessItems
                    showSizeChanger={false}
                    showQuickJumper={false}
                    hideOnSinglePage
                    itemRender={(page, type, originalElement) => {
                      if (type === "next") {
                        return (
                          <Button
                            loading={loading}
                            // disabled={loading || (selectedLeavePlanner && selectedLeavePlanner?.leave_planner?.company_user?.id != user?.id)}
                            className="btn btn-primary "
                            // type="Load More"
                            label="Load More"
                          />
                        );
                      }
                      return null;
                    }}
                  />
                </div>
              </div>
            </div>
          ) : (
            <div className="row">
              <div className="col-12">
                <div className="card shadow-sm" style={{ borderRadius: "12px", border: "1px solid #e0e0e0", overflow: "hidden" }}>
                  <style>{`
                    .modern-table .ant-table-tbody > tr {
                      background-color: #ffffff !important;
                    }
                    .modern-table .ant-table-tbody > tr:hover > td {
                      background-color: #f5f5f5 !important;
                    }
                    .modern-table .ant-table-thead > tr > th {
                      background-color: #f8f9fa !important;
                      font-weight: 600;
                      color: #333;
                      border-bottom: 2px solid #e0e0e0;
                      padding: 10px 12px;
                      font-size: 13px;
                    }
                    .modern-table .ant-table-tbody > tr > td {
                      border-bottom: 1px solid #f0f0f0;
                      padding: 10px 12px;
                      font-size: 13px;
                    }
                    .modern-table .ant-table-wrapper .ant-table-pagination.ant-pagination {
                      border-top: 1px solid #f0f0f0;
                      background-color: #ffffff;
                      border-bottom-left-radius: 12px;
                      border-bottom-right-radius: 12px;
                    }
                  `}</style>
                  <div className="table-responsive" style={{ overflowX: "auto" }}>
                    <Table
                      className="mb-0 modern-table"
                      style={{ 
                        borderRadius: "12px",
                        minWidth: "100%"
                      }}
                      scroll={{ x: "max-content" }}
                      columns={columns}
                      dataSource={uniformData}
                      rowKey={(record) => record.id}
                      loading={loading}
                      pagination={{
                        total: pageSettings?.total,
                        pageSize: pageSettings?.pageSize,
                        showSizeChanger: true,
                        pageSizeOptions: pageSizeOptions,
                        itemRender: itemRender,
                        position: "right",
                        current: pageSettings?.page,
                        showTotal: (total, range) =>
                          `${range[0]}-${range[1]} of ${total} items`,
                        style: { padding: "16px" }
                      }}
                      onChange={handleChange}
                    />
                  </div>
                </div>
              </div>
            </div>
          )}

      <AllUniformAddPopup getUniformList={getUniformList} setSelectedUniform={setSelectedUniform} setLoading={setLoading} selectedUniform={selectedUniform} loading={loading} reloadPage={reloadPage}  uniformModal={uniformModal} setUniformModal={setUniformModal} />
      {/* Delete Modal */}
      <DeleteModal deleteModal={deleteModal} setDeleteModal={setDeleteModal} deleteHandler={deleteHandler} Name="Delete Record" />
        </div>
      </div>

  
    

      <UniformsFilterDrawer
          searchPlaceholder={"Search Uniforms"}
          showFilterDrawer={showFilterDrawer}
          handleFilterDrawer={handleFilterDrawer}
          handleFilterChange={handleFilterChange}
          filters={filters}
          handleInputChange={handleInputChange}
          handleApplyFilter={handleApplyFilter}
          filterLoading={filterLoading}
          handleDateChange={handleDateChange}
/>
      {/* Delete Modal */}
      <style jsx>{`
        .dropdown-menu {
          z-index: 10000 !important;
        }
      `}</style>
    </>
  );
};

export default AllUniforms;
